import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BsArrowLeft } from 'react-icons/bs';


const MindARComponent = () => {
  const location = useLocation();
  const data = location.state;
  const target_url = data.gameData.game.targets_file
  const images = data.gameData.images;
  console.log('passed data', data)


  // change behaviour for backbutton. Set page refresh because I am not able to stop the proces otherwise.
  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      // navigate('/game'); // Redirect to your custom page
      let game_id = data.gameData.game.PartitionKey
      window.location.href = `/game/${game_id}`
    };

    window.addEventListener('popstate', handlePopState);

    // Push a dummy state to the history stack to intercept the back button
    window.history.pushState(null, '', window.location.href);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);



  useEffect(() => {
    const videoEls = document.querySelectorAll('video');
    const targetEls = document.querySelectorAll('[mindar-image-target]');
    targetEls.forEach((targetEl, index) => {
      targetEl.addEventListener('targetFound', () => {
        videoEls[index].currentTime = 0;
        videoEls[index].play();
      });

      targetEl.addEventListener('targetLost', () => {
        videoEls[index].pause();
      });
    });
  }, []);

  return (
    <>
      <div style={{ height: '100svh', position: 'relative' }}>
        {/* Back Button */}
        <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 1000 }}>

          <button
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
            onClick={() => {
              const game_id = data.gameData.game.PartitionKey;
              window.location.href = `/game/${game_id}`;
            }}
          >
            <BsArrowLeft size={16} />
            <span>Back</span>
          </button>

        </div>

        {/* AR Scene */}
        <a-scene mindar-image={`imageTargetSrc: ${target_url};`} color-space="sRGB"
          renderer="colorManagement: true, physicallyCorrectLights" vr-mode-ui="enabled: false"
          device-orientation-permission-ui="enabled: false">
          <a-assets>
            {images.map((image) => (
              <video key={image.RowKey} id={`video${image.RowKey}`} src={image.video} crossOrigin="anonymous" loop></video>
            ))}
          </a-assets>

          <a-camera position="0 0 0" look-controls="enabled: false"></a-camera>

          {images.map((image) => (
            <a-entity key={image.RowKey} mindar-image-target={`targetIndex: ${image.targetIndex}`}>
              <a-video rotation="0 0 0" position="0 0 0" height={image.height_scale} width="1" src={`#video${image.RowKey}`}></a-video>
            </a-entity>
          ))}
        </a-scene>
      </div>
    </>

  );
};

export default MindARComponent;
